import React from 'react'

const LiveChat = ({ providerId }) => {
  if (!providerId) return null
  return <script type="text/javascript" />
}

export default LiveChat
